var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 10,
    fill: "#9BD3DD",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3A.75.75 0 0 1 6 2.25h12a.75.75 0 0 1 .75.75v6.824c0 3.804-3.002 6.926-6.75 6.926s-6.75-3.122-6.75-6.926V3zm1.5.75v6.074c0 3.017 2.37 5.426 5.25 5.426s5.25-2.409 5.25-5.426V3.75H6.75z",
    fill: "#9BD3DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6.5A.75.75 0 0 1 2 5.75h4a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75c-2.487 0-4.75-2.079-4.75-5.75zm1.539.75c.217 2.017 1.312 3.081 2.461 3.398V7.25H2.789zM17.25 6.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75c0 3.671-2.263 5.75-4.75 5.75a.75.75 0 0 1-.75-.75v-5zm1.5.75v3.398c1.149-.317 2.244-1.381 2.461-3.398H18.75zM12 16.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75z",
    fill: "#9BD3DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.706 18.607a.75.75 0 0 1 .639-.357h5.176a.75.75 0 0 1 .626.337l1.98 3a.75.75 0 0 1-.627 1.163h-9a.75.75 0 0 1-.639-1.143l1.845-3zm1.058 1.143-.922 1.5h6.265l-.99-1.5H9.764z",
    fill: "#9BD3DD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupTrophy);
export default __webpack_public_path__ + "static/media/popupTrophy.7429f8b412d9a08a2ef6c57a07fcaeb3.svg";
export { ForwardRef as ReactComponent };